<template>
  <!-- 页脚组件 -->
  <footer class="footer">
    <div class="container">
      <!-- 主要内容区 -->
      <div class="footer__content">
        <!-- 左侧：公司信息 -->
        <div class="footer__section footer__about">
          <div class="footer__logo">
            <div class="footer__logo-icon">
              <img src="@/static/logo.jpg" alt="米晴科技" class="logo-image" />
            </div>
            <span class="footer__logo-text">米晴科技</span>
          </div>
          <p class="footer__description">
            专注于智能寄存柜智能存储解决方案，为酒吧、驾考、浴场等场景提供专业服务。
          </p>
          <div class="footer__social">
            <div
              v-for="item in socialLinks"
              :key="item.type"
              class="footer__social-item"
              @mouseenter="showQrCode = item.type"
              @mouseleave="showQrCode = null"
            >
              <i :class="item.iconClass">{{ item.text }}</i>
              <transition name="qrcode-fade">
                <div v-if="showQrCode === item.type && item.qrCode" class="qrcode-popup">
                  <img :src="item.qrCode" :alt="item.label" />
                  <p>{{ item.label }}</p>
                </div>
                <div v-else-if="showQrCode === item.type && item.phone" class="phone-popup">
                  <p class="phone-number">{{ item.phone }}</p>
                  <p class="phone-label">{{ item.label }}</p>
                </div>
              </transition>
            </div>
          </div>
        </div>

        <!-- 中间：快速链接 -->
        <div class="footer__section footer__links">
          <h4 class="footer__title">快速链接</h4>
          <ul class="footer__list">
            <li v-for="item in quickLinks" :key="item.path">
              <router-link :to="item.path" class="footer__link">
                {{ item.name }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- 右侧：联系方式 -->
        <div class="footer__section footer__contact">
          <h4 class="footer__title">联系我们</h4>
          <ul class="footer__list">
            <li class="footer__contact-item">
              <span class="footer__contact-label">客服电话：</span>
              <a href="tel:400-0811-363" class="footer__link footer__phone">400-0811-363</a>
            </li>
            <li class="footer__contact-item">
              <span class="footer__contact-label">邮箱：</span>
              <a href="mailto:miqingtec2020@163.com" class="footer__link footer__email">miqingtec2020@163.com</a>
            </li>
            <li class="footer__contact-item">
              <span class="footer__contact-label">地址：</span>
              <span>上海市嘉定区翔江公路1863号洲扬众创园8幢229</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- 底部版权信息 -->
      <div class="footer__bottom">
        <div class="footer__copyright">
          <p>&copy; 2026 米晴科技 All Rights Reserved</p>
          <!-- <p class="footer__icp">
            <a href="#" target="_blank" rel="noopener">粤ICP备xxxxxxxx号</a>
          </p> -->
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',

  data() {
    return {
      showQrCode: null,
      quickLinks: [
        { name: '产品服务', path: '/products' },
        { name: '场景方案', path: '/solutions' },
        { name: '服务案例', path: '/cases' },
        { name: '关于我们', path: '/about' },
        { name: '合作申请', path: '/apply' }
      ],
      socialLinks: [
        {
          type: 'wechat',
          label: '微信服务号',
          text: '微',
          iconClass: 'icon-wechat',
          qrCode: require('@/static/navImage/wechat.png')
        },
        {
          type: 'phone',
          label: '客服电话',
          text: '客',
          iconClass: 'icon-phone',
          phone: '400-0811-363'
        },
        // {
        //   type: 'email',
        //   label: '联系邮箱',
        //   text: '邮',
        //   iconClass: 'icon-email',
        //   qrCode: null // 邮箱通常不需要二维码
        // }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #2c2c2c;
  color: #e0e0e0;
  padding: $spacing-xxl * 1.5 0 $spacing-lg;

  &__content {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: $spacing-xxl;
    margin-bottom: $spacing-xxl;

    @include mobile {
      grid-template-columns: 1fr;
      gap: $spacing-xl;
    }
  }

  &__section {
    @include flex-column;
    gap: $spacing-md;
  }

  // Logo 区域
  &__logo {
    @include flex-center;
    gap: $spacing-sm;
    margin-bottom: $spacing-md;
    justify-content: flex-start;
  }

  &__logo-icon {
    width: 36px;
    height: 36px;
    @include flex-center;

    .logo-image {
      width: 100%;
      height: 100%;
      border-radius: 9px;
      object-fit: contain;
    }
  }

  &__logo-text {
    font-size: $font-size-lg;
    font-weight: 600;
    color: $bg-white;
  }

  &__description {
    font-size: $font-size-sm;
    line-height: 1.6;
    color: #b0b0b0;
    max-width: 400px;
  }

  // 社交媒体图标
  &__social {
    display: flex;
    gap: $spacing-md;
    margin-top: $spacing-sm;
  }

  &__social-item {
    position: relative;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: rgba($primary-color, 0.1);
    @include flex-center;
    transition: all $transition-normal;
    cursor: pointer;

    i {
      font-size: $font-size-sm;
      font-style: normal;
      color: $primary-color;
    }

    &:hover {
      background-color: $primary-color;
      transform: translateY(-3px);

      i {
        color: $bg-white;
      }
    }
  }

  // 二维码弹窗
  .qrcode-popup,
  .phone-popup {
    position: absolute;
    bottom: calc(100% + 12px);
    left: 50%;
    transform: translateX(-50%);
    background: $bg-white;
    padding: $spacing-md;
    border-radius: $border-radius-md;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 100;
    min-width: 150px;
    text-align: center;

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 6px solid transparent;
      border-top-color: $bg-white;
    }

    img {
      width: 120px;
      height: 120px;
      display: block;
      margin: 0 auto;
      border-radius: $border-radius-sm;
    }

    p {
      margin-top: $spacing-sm;
      font-size: $font-size-xs;
      color: $text-primary;
      font-weight: 500;
      white-space: nowrap;
    }
  }

  // 电话弹窗特殊样式
  .phone-popup {
    min-width: 180px;
    padding: $spacing-lg;

    .phone-number {
      font-size: $font-size-xl;
      font-weight: 700;
      color: $primary-color;
      margin: 0;
      letter-spacing: 1px;
    }

    .phone-label {
      margin-top: $spacing-sm;
      font-size: $font-size-xs;
      color: $text-secondary;
      font-weight: 500;
    }
  }

  // 二维码淡入淡出动画
  .qrcode-fade-enter-active,
  .qrcode-fade-leave-active {
    transition: opacity 0.3s, transform 0.3s;
  }

  .qrcode-fade-enter-from,
  .qrcode-fade-leave-to {
    opacity: 0;
    transform: translateX(-50%) translateY(5px);
  }

  .qrcode-fade-enter-to,
  .qrcode-fade-leave-from {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }

  // 标题
  &__title {
    font-size: $font-size-lg;
    font-weight: 600;
    color: $bg-white;
    margin-bottom: $spacing-sm;
  }

  // 链接列表
  &__list {
    @include flex-column;
    gap: $spacing-sm;
  }

  &__link {
    font-size: $font-size-sm;
    color: #b0b0b0;
    transition: color $transition-normal;

    &:hover {
      color: $primary-color;
    }
  }

  // 联系信息
  &__contact-item {
    font-size: $font-size-sm;
    color: #b0b0b0;
    line-height: 1.8;
  }

  &__contact-label {
    color: #909090;
  }

  &__phone {
    font-weight: 600;
    font-size: $font-size-base;
    color: $primary-color !important;
    letter-spacing: 0.5px;

    &:hover {
      color: $primary-hover !important;
      text-decoration: underline;
    }
  }

  &__email {
    font-weight: 500;
    font-size: $font-size-sm;
    color: $primary-color !important;
    word-break: break-all;
    transition: all $transition-normal;

    &:hover {
      color: $primary-hover !important;
      text-decoration: underline;
    }
  }

  // 底部版权
  &__bottom {
    padding-top: $spacing-xl;
    border-top: 1px solid rgba(#fff, 0.1);
  }

  &__copyright {
    text-align: center;
    font-size: $font-size-xs;
    color: #808080;

    p {
      margin-bottom: $spacing-xs;
    }

    a {
      color: #808080;
      transition: color $transition-normal;

      &:hover {
        color: $primary-color;
      }
    }
  }

  &__icp {
    margin-top: $spacing-xs;
  }
}
</style>
